export function competitionStatusLabel(status: string) {
  if (status === 'open') return 'open'
  if (status === 'submissions_closed') return 'closed'
  if (status === 'judging_closed') return 'judging closed'
  return status.replaceAll('_', ' ')
}

export function competitionIsOpen(status: string, closesAt: string) {
  return status === 'open' && new Date(closesAt).getTime() > Date.now()
}
